import React from 'react';
import {OfferVehiclesAndState} from '../components/offer';

const Offer = ({match}) =>
    <OfferVehiclesAndState offerId={match.params.offerId}/>;

export default Offer;

